<template>
  <v-app>
    <vue-progress-bar></vue-progress-bar>
     <v-main>
      <router-view/>
    </v-main>
    <greeting-toast></greeting-toast>
  </v-app>
</template>

<script>
import GreetingToast from './components/GreetingToast.vue';

export default {
  name: 'App',
  components: { GreetingToast },

  data: () => ({
    mini: false,
  }),
};
</script>

